import React, { useContext } from 'react';
import ModalHeader from 'react-bootstrap/ModalHeader';
import { Button, ModalBody, ModalFooter } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import axios from 'axios';
import { useAlert } from 'react-alert';
import { handlePresellError } from '../AlertUtils';
import AuthContext from '../../../authentication/AuthContext';

export default function ClearOrderModal(props) {
    let cas = useContext(AuthContext);
    let alert = useAlert();

    function clearOrder() {
        axios
            .post(
                window.CONFIG['ws.activoc-presell-public.orders.clear'].replace('{orderId}', props.orderId),
                {},
                {
                    headers: {
                        Authorization: cas,
                        'Content-Type': 'application/json',
                        'x-franchise-code': props.franchiseCode
                    }
                }
            )
            .then(response => {
                alert.success('Presell Order Cleared.');
                props.collapseDeals(true);
                props.refreshOrderQuantities();
                props.refreshOrderTotals(true);
                props.setShowClearConfirmation(false);
            })
            .catch(error => {
                handlePresellError(alert, error, 'Could not clear Presell Order.');
            });
    }

    function restoreAllocation() {
        axios
            .post(
                window.CONFIG['ws.activoc-presell-public.orders.submit'].replace('{orderId}', props.orderId),
                {},
                {
                    headers: {
                        Authorization: cas,
                        'Content-Type': 'application/json',
                        'x-franchise-code': props.franchiseCode
                    }
                }
            )
            .then(response => {
                alert.success('Presell Allocation Restored.');
                props.collapseDeals(true);
                props.refreshOrderTotals(true);
                props.setShowClearConfirmation(false);
                props.refreshOrderQuantities();
            })
            .catch(error => {
                handlePresellError(alert, error, 'Could not restore presell allocation.');
            });
    }

    const orderStatusIsRejected = props.orderStatus === 'REJECTED';

    return (
        <>
            <ModalHeader closeButton>
                <h2>Clear Order</h2>
            </ModalHeader>
            <ModalBody>
                {props.isAllocation
                    ? orderStatusIsRejected
                        ? 'This will restore the rejected allocation to its previous state with previously rejected order quantities, and make it visible to the retailer. Are you sure you want to restore?'
                        : 'This order is an allocation. If you delete this order you will not be able to retrieve it. Are you sure you want to delete?'
                    : 'Are you sure you want to clear all the quantities on this order?'}
            </ModalBody>
            <ModalFooter>
                <Button
                    variant={'secondary'}
                    data-testid={'close-modal-button'}
                    onClick={() => props.setShowClearConfirmation(false)}
                >
                    <FontAwesomeIcon icon={faTimesCircle} />
                    Cancel
                </Button>
                <Button
                    className={'logout'}
                    data-testid={'clear-order-button'}
                    onClick={orderStatusIsRejected ? restoreAllocation : clearOrder}
                >
                    {props.isAllocation ? (props.orderStatus === 'REJECTED' ? 'Restore' : 'Delete') : 'Clear'}
                </Button>
            </ModalFooter>
        </>
    );
}
